export default [
  {
    question: 'What Type of listing should I get?',
    answer:
      "Company Listings are best when you have 1 or more products that don't match your company names or if you have more than a single product or service offering. Company listings are only available on Enterprise plans and include unlimited product listings on the network of record.",
  },
]
